
import Vue from 'vue'
import { Message } from 'element-ui'
import Verify from '@/components/verifition/Verify.vue'

// v-dialogDrag: 弹窗拖拽
Vue.directive('dialogDrag', {
  bind(el, binding, vnode, oldVnode) {
    const dialogHeaderEl = el.querySelector('.el-dialog__header')
    const dragDom = el.querySelector('.el-dialog')
    dialogHeaderEl.style.cursor = 'move'

    // 获取原有属性 ie dom元素.currentStyle 火狐谷歌 window.getComputedStyle(dom元素, null);
    const sty = dragDom.currentStyle || window.getComputedStyle(dragDom, null)

    dialogHeaderEl.onmousedown = (e) => {
      // 鼠标按下，计算当前元素距离可视区的距离
      const disX = e.clientX - dialogHeaderEl.offsetLeft
      const disY = e.clientY - dialogHeaderEl.offsetTop

      // 获取到的值带px 正则匹配替换
      let styL, styT

      // 注意在ie中 第一次获取到的值为组件自带50% 移动之后赋值为px
      if (sty.left.includes('%')) {
        styL = +document.body.clientWidth * (+sty.left.replace(/\%/g, '') / 100)
        styT = +document.body.clientHeight * (+sty.top.replace(/\%/g, '') / 100)
      } else {
        styL = +sty.left.replace(/\px/g, '')
        styT = +sty.top.replace(/\px/g, '')
      };

      document.onmousemove = function (e) {
        // 通过事件委托，计算移动的距离
        const l = e.clientX - disX
        const t = e.clientY - disY

        // 移动当前元素
        dragDom.style.left = `${l + styL}px`
        dragDom.style.top = `${t + styT}px`

        // 将此时的位置传出去
        // binding.value({x:e.pageX,y:e.pageY})
      }

      document.onmouseup = function (e) {
        document.onmousemove = null
        document.onmouseup = null
      }
    }
  }
})

// v-dialogDragWidth: 弹窗宽度拖大 拖小
Vue.directive('dialogDragWidth', {
  bind(el, binding, vnode, oldVnode) {
    const dragDom = binding.value.$el.querySelector('.el-dialog')

    el.onmousedown = (e) => {
      // 鼠标按下，计算当前元素距离可视区的距离
      const disX = e.clientX - el.offsetLeft

      document.onmousemove = function (e) {
        e.preventDefault() // 移动时禁用默认事件

        // 通过事件委托，计算移动的距离
        const l = e.clientX - disX
        dragDom.style.width = `${l}px`
      }

      document.onmouseup = function (e) {
        document.onmousemove = null
        document.onmouseup = null
      }
    }
  }
})

/* // 检测屏幕鼠标长时间未使用
Vue.directive('inactivity-detection', {
  bind(el, binding) {
    // 使用 let 声明变量，而不是 const
    let timeout = binding.value.timeout || 300000 // 默认5分钟
    let warningTime = binding.value.warningTime || 270000 // 警告时间（4.5分钟）
    const callback = binding.value.callback || null // 检测后自动执行的回调函数
    const handleThenCallback = binding.value.handleThenCallback || null // 确认弹窗后点击确认后的回调函数
    let lastActivity = Date.now()
    let timer = null
    let warningShown = false

    const resetTimer = () => {
      lastActivity = Date.now()
    }

    const clearWarning = () => {
      warningShown = false
    }

    const showWarning = () => {
      const inactiveMinutes = Math.floor((Date.now() - lastActivity) / 60000)
      warningShown = true

      MessageBox.confirm(
        `您已经${inactiveMinutes}分钟没有进行操作了，系统即将暂停课程学习。建议您每隔一定时间操作鼠标一次，以便正常学习。`,
        '温馨提示',
        {
          confirmButtonText: '继续学习',
          cancelButtonText: '我知道了',
          type: 'warning',
          closeOnClickModal: false,
          closeOnPressEscape: false,
          showClose: false
        }
      ).then(() => {
        clearWarning()
        resetTimer()
        if (handleThenCallback && typeof handleThenCallback === 'function') {
          handleThenCallback()
        }
      }).catch(() => {
        clearWarning()
        resetTimer()
      })
    }

    const checkInactivity = () => {
      const now = Date.now()
      const inactiveTime = now - lastActivity

      // 弹窗显示期间不重复计时，等待用户操作后再重置倒计时
      if (warningShown) {
        return
      }

      if (inactiveTime >= warningTime && !warningShown) {
        showWarning()
      }

      if (inactiveTime >= timeout) {
        executeCallback()
      }
    }

    const executeCallback = () => {
      if (callback && typeof callback === 'function') {
        callback()
      } else {
        // Message.warning('由于长时间无操作，系统已暂停当前操作')
      }
    }

    // 监听活动事件
    const activityHandler = () => {
      resetTimer()
    }

    const events = ['mousemove', 'keydown', 'click', 'scroll', 'touchstart']
    events.forEach(event => {
      document.addEventListener(event, activityHandler, { passive: true })
    })

    // 开始检测
    timer = setInterval(checkInactivity, 1000)

    // 保存数据到元素
    el._inactivityDetection = {
      resetTimer: () => {
        resetTimer()
        Message.success('活动计时器已重置')
      },
      updateSettings: (newTimeout, newWarningTime) => {
        clearInterval(timer)
        // 若未传入新的 timeout，则沿用当前值
        timeout = typeof newTimeout === 'number' ? newTimeout : timeout
        // warningTime 优先使用入参，再退到当前值
        if (typeof newWarningTime === 'number') {
          warningTime = newWarningTime
        } else if (typeof timeout === 'number') {
          warningTime = timeout
        }
        timer = setInterval(checkInactivity, 1000)
      },
      getStatus: () => {
        return {
          lastActivity,
          inactiveTime: Date.now() - lastActivity,
          timeout,
          warningTime
        }
      },
      destroy: () => {
        clearInterval(timer)
        events.forEach(event => {
          document.removeEventListener(event, activityHandler)
        })
        delete el._inactivityDetection
      }
    }
  },

  update(el, binding) {
    // 当绑定值更新时，更新设置
    if (el._inactivityDetection && binding.value) {
      const { timeout, warningTime } = binding.value
      // 无论 timeout 是否有变，只要传入了新配置（timeout 或 warningTime 任一存在）就更新
      const hasTimeout = typeof timeout === 'number'
      const hasWarningTime = typeof warningTime === 'number'
      if (hasTimeout || hasWarningTime) {
        el._inactivityDetection.updateSettings(
          hasTimeout ? timeout : undefined,
          hasWarningTime ? warningTime : undefined
        )
      }
    }
  },

  unbind(el) {
    if (el._inactivityDetection) {
      el._inactivityDetection.destroy()
    }
  }
})
 */
Vue.directive('inactivity-detection', {
  bind(el, binding) {
    let timeout = binding.value.timeout || 300000 // 默认5分钟
    let warningTime = binding.value.warningTime || 270000 // 警告时间（4.5分钟）
    const callback = binding.value.callback || null
    const handleThenCallback = binding.value.handleThenCallback || null
    const captchaType = binding.value.captchaType || 'clickWord'
    let lastVerifyTime = Date.now()
    let timer = null
    let warningShown = false
    let verifyInstance = null

    const resetTimer = () => {
      lastVerifyTime = Date.now()
    }

    const clearWarning = () => {
      warningShown = false
    }

    const destroyVerify = () => {
      if (verifyInstance) {
        verifyInstance.$destroy()
        if (verifyInstance.$el && verifyInstance.$el.parentNode) {
          verifyInstance.$el.parentNode.removeChild(verifyInstance.$el)
        }
        verifyInstance = null
      }
    }

    const showWarning = () => {
      const inactiveMinutes = Math.floor((Date.now() - lastVerifyTime) / 60000)
      warningShown = true

      if (verifyInstance) {
        verifyInstance.show()
        return
      }

      const VerifyComponent = Vue.extend(Verify)
      verifyInstance = new VerifyComponent({
        propsData: {
          captchaType,
          mode: 'pop',
          showClose: false,
          title: 'tips',
          tip: `Please prove you are not a robot`
        }
      })

      verifyInstance.$on('success', () => {
        clearWarning()
        resetTimer()
        destroyVerify()
        if (handleThenCallback && typeof handleThenCallback === 'function') {
          handleThenCallback()
        }
      })

      verifyInstance.$mount()
      document.body.appendChild(verifyInstance.$el)
      verifyInstance.show()
    }

    const checkInactivity = () => {
      const now = Date.now()
      const inactiveTime = now - lastVerifyTime

      if (warningShown) {
        return
      }

      if (inactiveTime >= warningTime && !warningShown) {
        showWarning()
      }

      if (inactiveTime >= timeout) {
        executeCallback()
      }
    }

    const executeCallback = () => {
      if (callback && typeof callback === 'function') {
        callback()
      }
    }

    timer = setInterval(checkInactivity, 1000)

    el._inactivityDetection = {
      resetTimer: () => {
        resetTimer()
        Message.success('验证计时器已重置')
      },
      updateSettings: (newTimeout, newWarningTime) => {
        clearInterval(timer)
        timeout = typeof newTimeout === 'number' ? newTimeout : timeout
        if (typeof newWarningTime === 'number') {
          warningTime = newWarningTime
        } else if (typeof timeout === 'number') {
          warningTime = timeout
        }
        timer = setInterval(checkInactivity, 1000)
      },
      getStatus: () => {
        return {
          lastVerifyTime,
          inactiveTime: Date.now() - lastVerifyTime,
          timeout,
          warningTime
        }
      },
      destroy: () => {
        clearInterval(timer)
        destroyVerify()
        delete el._inactivityDetection
      }
    }
  },

  update(el, binding) {
    if (el._inactivityDetection && binding.value) {
      const { timeout, warningTime } = binding.value
      const hasTimeout = typeof timeout === 'number'
      const hasWarningTime = typeof warningTime === 'number'
      if (hasTimeout || hasWarningTime) {
        el._inactivityDetection.updateSettings(
          hasTimeout ? timeout : undefined,
          hasWarningTime ? warningTime : undefined
        )
      }
    }
  },

  unbind(el) {
    if (el._inactivityDetection) {
      el._inactivityDetection.destroy()
    }
  }
})



// WEBPACK FOOTER //
// ./src/utils/directives.js